import React, { useState } from 'react';
import { DirectoryListType } from '../components/directory-list/DirectoryList';
import { IResultState } from '../lib/resultInterfaces';
import { defaultAppState } from './DefaultAppState';
import IDoctorSpecialty from '../interfaces/IDoctorSpecialty';
import IFacilitySpecialty from '../interfaces/IFacilitySpecialty';
import IGenericResult from '../interfaces/IGenericResult';
import { IPlan } from '../interfaces/IPlan';
import IDistance from '../interfaces/IDistance';
import IOrigin from '../interfaces/IOrigin';
import ISearch from '../interfaces/ISearch';

// Creating the app context with the default state
export const AppContext = React.createContext(defaultAppState);

// Provider
export const AppProvider = ({ children }: any) => {
  // State
  const [isDirectorySelected, setSelected] = useState(defaultAppState.isDirectorySelected);
  const [directoryListType, setListType] = useState(defaultAppState.directoryListType);
  const [cacheTime, setCacheTime] = useState(defaultAppState.cacheTime);
  const [stateList, setStateList] = useState(defaultAppState.stateList);
  const [plansData, setPlansData] = useState(defaultAppState.plansData);
  const [plan, setPlan] = useState(defaultAppState.plan);
  const [planCode, setPlanCode] = useState(defaultAppState.planCode);
  const [planName, setPlanName] = useState(defaultAppState.planName);
  const [shortPlanName, setShortPlanName] = useState(defaultAppState.shortPlanName);
  const [planState, setPlanState] = useState(defaultAppState.planState);
  const [disclaimerUrl, setDisclaimerUrl] = useState(defaultAppState.disclaimerUrl);
  const [doctorSpecialties, setDoctorSpecialties] = useState(defaultAppState.doctorSpecialties);
  const [facilitySpecialties, setFacilitySpecialties] = useState(defaultAppState.facilitySpecialties);
  const [pharmacySpecialties, setPharmacySpecialties] = useState(defaultAppState.pharmacySpecialties);
  const [selectedSpecialty, setSelectedSpecialty] = useState(defaultAppState.selectedSpecialty);
  const [chosenSpecialty, setChosenSpecialty] = useState(defaultAppState.chosenSpecialty);
  const [reportYear, setReportYear] = useState(defaultAppState.reportYear);
  const [location, setLocation] = useState(defaultAppState.location);
 
  // Use origin as origin of Plan State Capital
  //const [origin, setOrigin] = useState(defaultAppState.origin);
  const [isDisabled, setisDisabled] = useState(defaultAppState.isDisabled);
  const [search, setSearch] = useState(defaultAppState.search);

  // distance is needed - 'Select a distance from zipcode'
  const [distance, setDistance] = useState(defaultAppState.distance);
  const [name, setName] = useState(defaultAppState.name);
  const [results, setResults] = useState(defaultAppState.results);
  const [displayedResults, setDisplayedResults] = useState(defaultAppState.displayedResults);
  const [ sitePlans, setSitePlans ] = useState<IPlan[]>(defaultAppState.sitePlans);
  //const [ planStates, setPlanStates ] = useState([]);

  /*const state_arr = plansData.map((item, index) => (
      setPlanStates[(item.state)]
    ));*/
  //var planStates = [];
  /*plansData.forEach((planData, index) => {
	setPlanStates.push(planData.state);
	// console.log('planStates->'+planData.state);
  });
  console.log('planStates->'+setPlanStates);*/
  // Custom Hooks
  const updateSelected = (isSelected: boolean) => setSelected(isSelected);
  const updateListType = (type: DirectoryListType) => setListType(type);
  const updateCacheTime = (time: string) => setCacheTime(time);
  const updateStateList = (states: IResultState[]) => setStateList(states);
  const updatePlansData = (plansData: IPlan[]) => setPlansData(plansData);
  const updatePlan = (plan: IPlan | null) => setPlan(plan);
  const updatePlanCode = (planCode: string | undefined) => setPlanCode(planCode);
  const updatePlanName = (planName: string) => setPlanName(planName);
  const updateShortPlanName = (shortPlanName: string) => setShortPlanName(shortPlanName);
  const updatePlanState = (state: string) => setPlanState(state);
  const updateDisclaimerUrl = (url: string) => setDisclaimerUrl(url);
  const updateDoctorSpecialties = (specialties: IDoctorSpecialty[] | null) => setDoctorSpecialties(specialties);
  const updateFacilitySpecialties = (specialties: IFacilitySpecialty[] | null) => setFacilitySpecialties(specialties);
  const updatePharmacySpecialties = (specialties: string[] | null) => setPharmacySpecialties(specialties);
  const updateSelectedSpecialty = (specialty: string) => setSelectedSpecialty(specialty);
  const updateChosenSpecialty = (specialty: string) => setChosenSpecialty(specialty);
  const updateReportYear = (reportYear: number) =>  setReportYear(reportYear);
  const updateLocation = (location: string) => setLocation(location);
  //const updateOrigin = (origin: IOrigin) => setOrigin(origin);
  const updateIsDisabled = (isDisabled: boolean) => setisDisabled(isDisabled);
const updateSearch = (search: ISearch | null) => setSearch(search ?? defaultAppState.search);
  const updateDistance = (distance: IDistance) => setDistance(distance);
  const updateName = (name: string) => setName(name);
const updateResults = (results: IGenericResult[][]) => setResults(results);
  const updateDisplayedResults = (results: IGenericResult[]) => setDisplayedResults(results);
  const updateSitePlans = (sitePlans: IPlan[]) => setSitePlans(sitePlans);
  const pcp = search?.pcp ?? null;
  const updatePCP = (pcp: string | null) => {
  setSearch((prev: ISearch) => ({
    ...prev,
    pcp: pcp,
  }));
};
  // Providing State and Update Functions to the App via the useState method
  return (
    <AppContext.Provider
      value={{
        isDirectorySelected,
        directoryListType,
        cacheTime,
        stateList,
        plansData,
        plan,
        planCode,
        planName,
		shortPlanName,
        planState,
        disclaimerUrl,
        doctorSpecialties,
        facilitySpecialties,
        pharmacySpecialties,
        selectedSpecialty,
        chosenSpecialty,
        reportYear,
        location,
        //origin,
        isDisabled,
        search,
        distance,
        name,
        results,
        pcp,
        displayedResults,
        sitePlans,
        updateSelected,
        updateListType,
        updateCacheTime,
        updateStateList,
        updatePlansData,
        updatePlan,
       
        updatePlanCode,
        updatePlanName,
		updateShortPlanName,
        updatePlanState,
        updateDisclaimerUrl,
        updateDoctorSpecialties,
        updateFacilitySpecialties,
        updatePharmacySpecialties,
        updateSelectedSpecialty,
        updateChosenSpecialty,
        updateReportYear,
        updateLocation,
        //updateOrigin,
        updateIsDisabled,
        updateSearch,
        updatePCP,
        updateDistance,
        updateName,
        updateResults,
        updateDisplayedResults,
        updateSitePlans
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
